module.exports = __webpack_public_path__ + "static/media/arrow-city-direction-svgrepo-com.6c47d039.svg";